import "react-toastify/dist/ReactToastify.css";

import { Box, Container, Typography } from "@mui/material";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { Nav } from "./Nav/index";

const Layout = () => {
  return (
    <Box
      className="App"
      display="flex"
      flexDirection="column"
      bgcolor="background.paper"
      pt={{ xs: "56px", md: "69px" }}
    >
      <Nav />
      <Container
        className="site-layout"
        maxWidth="xl"
        sx={{
          bgcolor: "background.paper",
          display: "flex",
          minHeight: {
            xs: "calc(100vh - 56px - 56px)",
            md: "calc(100vh - 69px - 56px)"
          }
        }}
      >
        <Box className="site-layout-background" width={"100%"}>
          <ToastContainer
            theme="colored"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <Outlet />
        </Box>
      </Container>
      <Box
        component="footer"
        bgcolor="background.default"
        display="flex"
        alignItems="center"
        justifyContent="center"
        paddingY={2}
      >
        <Typography textAlign="center">Mediacross srl ©2022</Typography>
      </Box>
    </Box>
  );
};

export default Layout;
